import { createTheme } from '@mui/material'
import { breakpoints } from './breakpoints'
import { shape } from './shapes'
import { typography } from './typography'
import { getComponents } from './globalComponentOverrides'
import { paletteLight, paletteDark } from './palettes'

export const lightTheme = createTheme({
  palette: { mode: 'light', ...paletteLight },
  typography: typography,
  breakpoints: breakpoints,
  components: {
    ...getComponents(paletteLight),
    MuiCssBaseline: {
      styleOverrides: {
        '::-webkit-scrollbar': {
          width: '6px',
          height:'6px',
          backgroundColor: '#E3E3E3',
          borderRadius: '10px',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: '#C6C6C8',
          borderRadius: '10px',
        },
        '@-moz-document url-prefix()': {
          scrollbarWidth: 'thin',
        },
      },
    },
  },
  shape: shape,
})

export const darkTheme = createTheme({
  palette: { mode: 'dark', ...paletteDark },
  typography: typography,
  breakpoints: breakpoints,
  components: { ...getComponents(paletteDark),
    MuiCssBaseline: {
      styleOverrides: {
        '::-webkit-scrollbar': {
          width: '6px',
          height:'6px',
          backgroundColor: '#3D3D3E',
          borderRadius: '10px',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: '#868689',
          borderRadius: '10px',
        },
        '@-moz-document url-prefix()': {
          scrollbarWidth: 'thin',
        },
      },
    },
  },
  shape: shape,
})
